export const IMPORT_SUMMARY_TABLE_ROWS = [
  ["ts", "status", "trigger", "total_products", "products_imported", "unchanged_products"],
  ["new_products", "deactivated_products", "undeactivated_products", "deleted_products", "undeleted_products", null],
];

export const formatSummaryFieldLabel = (key) => {
  if (key === "ts") {
    return "ULTIMO IMPORT";
  }
  return String(key || "").replace(/_/g, " ").toUpperCase();
};

export const formatSummaryCounter = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) {
    return "—";
  }
  return parsed.toLocaleString("it-IT");
};

export const readSummaryCounter = (summary, key) => formatSummaryCounter(summary?.[key]);
